<header class="status-selection-dialog__header">
  {{ data.title | translate }}
</header>

<section class="status-selection-dialog__body">
  <ocp-status-dropdown
    [value]="selectedValue()"
    [style]="'width: 100%;'"
    [placeholder]="data.placeholder ?? ''"
    [ariaLabel]="data.ariaLabel ?? data.title"
    (statusChange)="onStatusChange($event)"
  />
</section>

<div class="status-selection-dialog__actions">
  <button
    hlmBtn
    type="button"
    class="status-selection-dialog__submit-button"
    [disabled]="selectedValue() === null"
    (click)="onConfirm()"
  >
    <ocp-themed-icon name="checkmark.svg" mode="swap" />
    {{ data.confirmLabel ?? 'Ok' | translate }}
  </button>
  <button
    hlmBtn
    type="button"
    variant="secondary"
    class="status-selection-dialog__cancel-button"
    (click)="onCancel()"
  >
    <ocp-themed-icon name="cross.svg" />
    {{ data.cancelLabel ?? 'Cancel' | translate }}
  </button>
</div>
